//Promotion MOQ
export const GET_MOQ_CARRY_FORWARD_REPORT = 'promotionwisemoq/GetMOQCarryforwardReport?{params}';
export const GET_SALES_DETAILS_MOQ = 'promotionwisemoq/GetMOQSalesDetails?{params}';
export const DOWNLOAD_SALES_DETAILS_MOQ = 'promotionwisemoq/exportMOQSalesDetails?{params}';
export const DOWNLOAD_MOQ_CARRY_FORWARD_REPORT = 'promotionwisemoq/exportMOQCarryforward?{params}';
export const GET_MOQ_DROPDOWN = 'promotionwisemoq/getProductPromotionDropdown';
export const GET_PENDING_USERS = 'AwfApproval/getawfusersforapproval?{params}';
export const DOWNLOAD_PENDING_USERS = 'AwfApproval/downloadawfuserforapproval?{params}';
export const UPDATE_APPROVE_STATUS = 'AwfApproval/approve';
export const UPDATE_REJECT_STATUS = 'AwfApproval/reject';
export const GET_AWF_LEVEL = 'AwfApproval/getawfleveldata';